/**
 * Renders a product description. `html` comes from the API's descriptionHtml
 * (@memeup/shared), which keeps only allowlisted formatting tags with no
 * attributes, so it is safe to insert.
 */
export function Description({ html, className = "" }: { html: string; className?: string }) {
  if (!html) return null;
  return (
    <div
      className={`prose ${className}`}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: sanitized server-side by descriptionHtml (attribute-free allowlisted tags only)
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
